import * as React from 'react';
import * as classnames from 'classnames';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';

import * as uuidv4 from 'uuid/v4';
import { MAX_UPLOAD_SIZE_BYTES } from '@nexxt/common/constants';
import { uploadFile } from '../../../../../services/media.service';
import NotifyHOC from '../../../../../HOC/Notifications';

interface MediaUploaderProps {
    size?: 'full' | 'single';
    isMultiple?: boolean;
    type?: string;
    toastNotification?: any;
    handleUploadMedia: (
        id: string,
        status: 'uploading' | 'complete',
        url?: string,
        filename?: string,
        type?: string
    ) => void;
    uploadFile: (acceptedFile: any, type: string) => Promise<any>;
}

const acceptFormats = {
    image: 'image/jpeg, image/png, image/gif',
    video: 'video/mp4',
    audio: 'audio/*',
    default: 'image/jpeg, image/png, image/gif, video/mp4, text/*, audio/*'
};

const MediaUploader: React.FC<MediaUploaderProps> = ({
    isMultiple,
    type,
    size,
    toastNotification,
    handleUploadMedia,
    uploadFile
}: MediaUploaderProps) => {
    const uploadMedia = async (accepted, rejected) => {
        try {
            if (rejected?.length) {
                throw 'includes Unsupported types';
            }
            await accepted.forEach(async (media) => {
                const uuid = uuidv4();
                handleUploadMedia(uuid, 'uploading');

                const response = await uploadFile(media, type);

                handleUploadMedia(
                    uuid,
                    'complete',
                    response?.path,
                    response?.filename,
                    response?.mimetype
                );
            });
            toastNotification.success('Upload completed!');
            //notification
        } catch (err) {
            console.error(err);
            toastNotification.error(
                'Failed to upload images. Please check images and try again'
            );

            //notification
        }
    };

    return (
        <Dropzone
            data-test="video-upload"
            accept={acceptFormats[type]}
            multiple={!!isMultiple}
            maxSize={MAX_UPLOAD_SIZE_BYTES}
            onDrop={uploadMedia}
            // disableClick
        >
            {({ getRootProps, getInputProps }: any) => (
                <div
                    {...getRootProps()}
                    className={classnames('uploader--dropzone', {
                        'uploaded-only': size === 'single'
                    })}
                >
                    <input {...getInputProps()} />
                    <div className="uploader--dropzone--placeholder">
                        Drop your option images here, or{' '}
                        <span
                            className="uploader--dropzone--open"
                            // onClick={() => dropzoneRef?.open()}
                            // {...getInputProps()}
                        >
                            browse
                        </span>
                        .
                        <div className="uploader--dropzone--format">
                            GIF (upto 4MB), PNG or JPG (no limit)
                        </div>
                    </div>
                </div>
            )}
        </Dropzone>
    );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
    uploadFile: (acceptedFile: any, type: string) =>
        dispatch(uploadFile(acceptedFile, type))
});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(MediaUploader)
);
